const fixAlt = (el) => {
    if (!el.hasAttribute('alt')) el.setAttribute('alt', '');
};

const fixButtonRole = (el) => {
    if (el.tagName === 'BUTTON' && el.getAttribute('role') === 'group') {
        el.removeAttribute('role');
    }
}

document.querySelectorAll('img').forEach(fixAlt);

new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (node.tagName === 'IMG') fixAlt(node);
            if (node.tagName === 'BUTTON') fixButtonRole(node);
            node.querySelectorAll('img').forEach(fixAlt);
            node.querySelectorAll('button').forEach(fixButtonRole);
        });
    });
}).observe(document.body, { childList: true, subtree: true });